module.exports = __webpack_public_path__ + "static/media/instagram.0fd67b97.svg";